export const COMMON = {
                         DUMMY_IMAGE: '/images/components/sidebar/dummy-user-image.png',
                         text: {
                                    LAST_WEEK: 'Last Week',
                                    THIS_MONTH: 'This Month',
                                    THIS_YEAR: 'This Year',
                                    ALL_TIME: 'All Time',
                                    CUSTOM: 'Custom'
                               }
}
